import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import Drawer from '../Drawer/Drawer'
import DrinkNumber from '../DrinkNumber/DrinkNumber'
import { WeekDays } from '../../constants/weekDays'
import ValidateButton from '../ValidateButton/ValidateButton'
import EditResponse from '../EditResponse/EditResponse'
import { IWeekConsumptionStore, IDayConsumption } from '../../store/WeekConsumptionStore'
import { alcoolList } from '../../constants/alcoolList'
import IddleMessage from '../IddleMessage/IddleMessage'
import Icon from '../Icon/Icon'

interface IDayConsumptionProps {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  WeekConsumptionStore?: IWeekConsumptionStore
  consumptionDayNumber: number
  stepIndex: number
  lengthConsumptionDays?: number
}

interface IDayConsumptionState {
  isAnswered: boolean
  needValidation: boolean
  selectedValue: IDayConsumption
  showInfoModal: boolean
}

@inject('UserStore', 'LayoutStore', 'WeekConsumptionStore')
@observer
class DayConsumption extends React.Component<IDayConsumptionProps, IDayConsumptionState> {
  public constructor(props: IDayConsumptionProps) {
    super(props)

    let initialValue = this.props.WeekConsumptionStore!.getDayConsumption(
      this.props.consumptionDayNumber
    )

    if (initialValue === null) {
      initialValue = {
        dayIndex: this.props.consumptionDayNumber,
        beerCount: 0,
        cocktailCount: 0,
        strongAlcoolCount: 0,
        wineCount: 0,
      }
    }

    this.state = {
      isAnswered: this.props.LayoutStore!.currentStep > 6,
      needValidation: true,
      selectedValue: initialValue,
      showInfoModal: false,
    }
  }

  public render() {
    const weekday = this.getCurrentWeekDay()
    let catchPhrase: any
    if (this.props.stepIndex === 0) {
      catchPhrase = "Combien de verres d'alcool avez-vous bu"
    } else {
      catchPhrase = 'Et'
    }

    return (
      <fieldset>
        <div className="Row Row--mw500 Row--mw500b">
          <legend>
            {catchPhrase} <span className="colorRouge colorRouge--bold">{weekday.label}</span> ?{' '}
          </legend>
        </div>
        {this.state.isAnswered && (
          <div className="Row Row--center">
            <div className="ResultsConsumption__day DayConsupmtion-card">
              <h5 className="ResultsConsumption__day-title">
                {this.getWeekDay(this.state.selectedValue.dayIndex)}
              </h5>
              <div className="ResultsConsumption__day-consumption-container">
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="demi" />
                  <span className="ResultsConsumption__day-howmuch">
                    {this.state.selectedValue.beerCount}
                  </span>
                  <p className="ResultsConsumption__day-label">demi(s) de bière</p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="vin" />
                  <span className="ResultsConsumption__day-howmuch">
                    {this.state.selectedValue.wineCount}
                  </span>
                  <p className="ResultsConsumption__day-label">verre(s) de vin</p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="fort" />
                  <span className="ResultsConsumption__day-howmuch">
                    {this.state.selectedValue.strongAlcoolCount}
                  </span>
                  <p className="ResultsConsumption__day-label">verre(s) d’alcool fort </p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="cocktail" />
                  <span className="ResultsConsumption__day-howmuch">
                    {this.state.selectedValue.cocktailCount}
                  </span>
                  <p className="ResultsConsumption__day-label">cocktail(s)</p>
                </div>
              </div>
            </div>

            {/* <div className="DrinkNumberResponse DrinkNumberResponse--response">
              {alcoolList.map((alcool, index) => {
                console.log(this.state.selectedValue)
                return this.state.selectedValue[alcool.targetState] !== 0 ? (
                  <div className="DrinkNumberResponse-row" key={`day-result-${index}`}>
                    <ul className="DrinkNumberResponse-icons">{this.createAlcoolIcons(alcool)}</ul>
                    <p className="DrinkNumberResponse-label">
                      <span className="colorRouge">
                        {this.state.selectedValue[alcool.targetState]}
                      </span>
                      {alcool.resultLabel}
                    </p>
                  </div>
                ) : (
                  ''
                )
              })}
            </div> */}
            <EditResponse functionEdit={this.resetAnswer.bind(this, weekday.value)} />
          </div>
        )}

        {!this.state.isAnswered && (
          <Drawer>
            <ul className="Drawer-drink">
              {alcoolList.map((alcool, index) => {
                return (
                  <DrinkNumber
                    key={`alcool-control-${index}`}
                    icon={alcool.icon}
                    label={alcool.label}
                    dosage={alcool.dosage}
                    onClickMinusButton={this.decrementAlcool.bind(this, alcool.targetState)}
                    onClick={this.onClick.bind(this, alcool.targetState)}
                    onInputChange={this.onInputChange.bind(this, alcool.targetState)}
                    onBlur={this.onBlur.bind(this, alcool.targetState)}
                    inputValue={this.state.selectedValue[alcool.targetState]}
                    onClickPlusButton={this.incrementAlcool.bind(this, alcool.targetState)}
                  />
                )
              })}
            </ul>
          </Drawer>
        )}

        {!this.state.isAnswered && this.state.needValidation && this.getDrinkCount() > 0 && (
          <div className="control-color-wrapper">
            <ValidateButton
              onClick={this.setDayConsumption}
              validateLabel={
                this.props.stepIndex === this.props.lengthConsumptionDays - 1
                  ? 'Je continue'
                  : 'Passez au jour suivant'
              }
            />
          </div>
        )}

        {this.getDrinkCount() === 0 && (
          <div className="control-color-wrapper">
            <IddleMessage iddleMessageLabel="Saisissez votre consommation d'alcool" />
          </div>
        )}
      </fieldset>
    )
  }

  /**
   * Increment the alcool count based on alcoolType
   * Explanation: [alcoolStateName] is a computed access key
   * @param alcoolStateName
   */
  private incrementAlcool = (alcoolStateName: keyof IDayConsumption) => {
    const mutation = (prevState: IDayConsumptionState) => ({
      selectedValue: {
        ...prevState.selectedValue,
        [alcoolStateName]:
          prevState.selectedValue[alcoolStateName] < 10
            ? prevState.selectedValue[alcoolStateName] + 1
            : prevState.selectedValue[alcoolStateName],
      },
    })

    this.setState(mutation)
  }

  /**
   * Decrement the alcool count based on alcoolType
   * Explanation: [alcoolStateName] is a computed access key
   * @param alcoolStateName
   */
  private decrementAlcool = (alcoolStateName: string) => {
    const mutation = (prevState: IDayConsumptionState) => ({
      selectedValue: {
        ...prevState.selectedValue,
        [alcoolStateName]:
          prevState.selectedValue[alcoolStateName] > 0
            ? prevState.selectedValue[alcoolStateName] - 1
            : prevState.selectedValue[alcoolStateName],
      },
    })

    this.setState(mutation)
  }

  private getCurrentWeekDay() {
    return WeekDays.find((element) => {
      return element.value === this.props.consumptionDayNumber
    })
  }

  private setDayConsumption = () => {
    this.setState({ isAnswered: true, needValidation: false })
    this.props.WeekConsumptionStore.addDayConsumption(this.state.selectedValue)
    this.props.WeekConsumptionStore!.incrementCurrentDayIndex()
    if (
      this.props.UserStore!.consumptionDays.length ===
        this.props.WeekConsumptionStore!.WeekConsumption.length &&
      this.props.UserStore!.consumptionDays.length === this.props.stepIndex + 1
    ) {
      this.props.LayoutStore!.incrementStep()
    }
  }

  private resetAnswer = (weekdayNumber: number) => {
    this.setState({ isAnswered: false, needValidation: true })
    this.props.WeekConsumptionStore.addDayConsumption({
      dayIndex: this.props.consumptionDayNumber,
      beerCount: 0,
      wineCount: 0,
      strongAlcoolCount: 0,
      cocktailCount: 0,
    })
    this.props.WeekConsumptionStore!.setCurrentDayIndex(this.props.stepIndex)
    this.props.LayoutStore.setStep(5)
  }

  private onInputChange = (alcoolStateName: string, e: React.ChangeEvent<HTMLInputElement>) => {
    let value = parseInt(e.target.value.replace(/\D/, ''), 10)

    if (e.target.value === '') {
      value = 0
    }

    value = value > 10 ? 10 : value
    value = value < 0 ? 0 : value

    if (!isNaN(value)) {
      const mutation = (prevState: IDayConsumptionState) => ({
        selectedValue: {
          ...prevState.selectedValue,
          [alcoolStateName]: value,
        },
      })

      this.setState(mutation)
    }
  }

  private getDrinkCount = () => {
    return (
      this.state.selectedValue.beerCount +
      this.state.selectedValue.wineCount +
      this.state.selectedValue.strongAlcoolCount +
      this.state.selectedValue.cocktailCount
    )
  }

  private onClick = (alcoolStateName: string, e: React.MouseEvent<HTMLInputElement>) => {
    const mutation = (prevState: IDayConsumptionState) => ({
      selectedValue: {
        ...prevState.selectedValue,
        [alcoolStateName]: null,
      },
    })

    this.setState(mutation)
  }

  private onBlur = (alcoolStateName: string, e: React.FocusEvent<HTMLInputElement>) => {
    let value = parseInt(e.currentTarget.value.replace(/\D/, ''), 10)
    if (e.currentTarget.value === '') {
      value = 0
    }
    value = value > 10 ? 10 : value
    value = value < 0 ? 0 : value
    const mutation = (prevState: IDayConsumptionState) => ({
      selectedValue: {
        ...prevState.selectedValue,
        [alcoolStateName]: value,
      },
    })

    this.setState(mutation)
  }

  private getWeekDay(value: number) {
    const foundDay = WeekDays.find((el) => el.value === value)
    if (!foundDay) {
      return ''
    }
    return foundDay.label
  }
}

export default DayConsumption



// WEBPACK FOOTER //
// ./src/components/DayConsumption/DayConsumption.tsx